import { RiCheckboxBlankLine, RiCheckboxFill, 
    RiCheckboxIndeterminateFill 
} from 'react-icons/ri'

import { Container } from './style';

export function Checkbox({ selected, handleChangeStatus, size, absolute }) {
  return(
    <Container 
        onClick={() => handleChangeStatus()}
        size={size}
        absolute={absolute}
    >
        {
            selected  === 1 ?
            <RiCheckboxFill className="purple" />
            :
            selected  === 0 ?
            <RiCheckboxBlankLine />
            :
            <RiCheckboxIndeterminateFill className="purple" />
        }
    </Container>
  )
}

